import { IAntDProTableRequest } from "../../../general/type/general.types";
import { apiRequest } from "../../../services/api";
import { IUserRequest, IApiResponseGetUsers } from "../type/user";

export const getUsers = async (
  tableRequest: IAntDProTableRequest
): Promise<IApiResponseGetUsers> => {
  const response = await apiRequest("GET", "/users", tableRequest);
  return response.data;
};

export const getUsersByRole = async (
  role: string,
  params?: {
    name?: string;
    limit?: number;
    page?: number;
    [key: string]: any;
  }
): Promise<IApiResponseGetUsers> => {
  const response = await apiRequest("GET", `/users/role/${role}`, { params });
  return response.data;
};

export const getUsersByBranchId = async (
  branchId: string,
  params?: {
    limit?: number;
    page?: number;
    [key: string]: any;
  }
): Promise<IApiResponseGetUsers> => {
  const response = await apiRequest("GET", `/users/branch/${branchId}`, {
    params,
  });
  return response.data;
};

export const createUser = async (data: IUserRequest) => {
  const payload = {
    name: data.name,
    icNumber: data.icNumber,
    ...(data.address && { address: data.address }),
    phoneNumber: data.phoneNumber,
    email: data.email,
    password: data.password,
    role: data.role,
    ...(data.branchId && { branchId: data.branchId }),
    isEmailVerified: data.isEmailVerified,
    ...(data.agency && { agency: data.agency }),
    ...(data.bankAccountNumber && {
      bankAccountNumber: data.bankAccountNumber,
    }),
    ...(data.bankAccountName && { bankAccountName: data.bankAccountName }),
    ...(data.kswpNumber && { kswpNumber: data.kswpNumber }),
    ...(data.position && { position: data.position }),
    ...(data.department && { department: data.department }),
    ...(data.employeeNumber && { employeeNumber: data.employeeNumber }),
    ...(data.taxCategory && { taxCategory: data.taxCategory }),
  };
  const response = await apiRequest<IUserRequest>("POST", "/users", payload);
  return response.data;
};

export const getUserById = async (id: string | undefined) => {
  const response = await apiRequest<IApiResponseGetUsers>(
    "GET",
    `/users/${id}`
  );
  return response.data;
};

export const editUser = async (id: string, data: IUserRequest) => {
  const payload = {
    name: data.name,
    icNumber: data.icNumber,
    ...(data.address && { address: data.address }),
    phoneNumber: data.phoneNumber,
    email: data.email,
    role: data.role,
    ...(data.branchId && { branchId: data.branchId }),
    isEmailVerified: data.isEmailVerified,
    ...(data.password && { password: data.password }),
    ...(data.agency && { agency: data.agency }),
    ...(data.bankAccountNumber && {
      bankAccountNumber: data.bankAccountNumber,
    }),
    ...(data.bankAccountName && { bankAccountName: data.bankAccountName }),
    ...(data.kswpNumber && { kswpNumber: data.kswpNumber }),
    ...(data.position && { position: data.position }),
    ...(data.department && { department: data.department }),
    ...(data.employeeNumber && { employeeNumber: data.employeeNumber }),
    ...(data.taxCategory && { taxCategory: data.taxCategory }),
  };

  const response = await apiRequest<IUserRequest>(
    "PATCH",
    `/users/${id}`,
    payload
  );
  return response.data;
};

export const archiveUser = async (id: string) => {
  const response = await apiRequest("PATCH", `/users/${id}/archive`);
  return response.data;
};
